import { GANTT_DEFAULT_ZOOM } from '../../../constants/gantt/gantt.const';

export const GAP_TRIP_ASSIGNMENT_ID = 'puck-assignment-cancel';

export const GANTT_DEFAULT_ZOOM_LEVEL = GANTT_DEFAULT_ZOOM;
export const DEFAULT_WINDOW_TO_FETCH = 7;
export const DRIVER_COLUMN__DEFAULT_WIDTH = 240;
export const DRIVER_COLUMN_MAX_WIDTH = 790;
export const DRIVER_COLUMN_MIN_WIDTH = 180;
